/* eslint-disable no-restricted-globals */
import { useEffect } from 'react';

type UseServiceWorkerOptions = {
  onUpdatePrompt?: () => Promise<boolean>; // Allows using a custom modal or dialog
};

export function useServiceWorker({
  onUpdatePrompt,
}: UseServiceWorkerOptions = {}) {
  const onControllerChange = () => {
    window.location.reload();
  };

  const registerSW = async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js');

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', async () => {
          if (
            newWorker.state === 'installed' &&
            navigator.serviceWorker.controller
          ) {
            const shouldUpdate = onUpdatePrompt
              ? await onUpdatePrompt()
              : confirm('A new version is available. Update now?');

            if (shouldUpdate) {
              newWorker.postMessage({ type: 'SKIP_WAITING' });
            }
          }
        });
      });

      navigator.serviceWorker.addEventListener(
        'controllerchange',
        onControllerChange
      );
    } catch (error) {
      console.error('Service worker registration failed:', error);
    }
  };

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    window.addEventListener('load', registerSW);

    return () => {
      window.removeEventListener('load', registerSW);
      navigator.serviceWorker.removeEventListener(
        'controllerchange',
        onControllerChange
      );
    };
  }, [onUpdatePrompt]);
}
